import Vue from 'vue';
import AdManager from 'vue-google-ad-manager';

let mappings = {
  filter: [
    { window: [770,0], sizes: [ [300, 250] ] },
    { window: [0,0], sizes: [ [320, 50] ] }
  ]
};

let sizes = {
  filter: [ [300,250], [320, 50] ]
};

Vue.use(AdManager, {
  id: '21899944170',
  mappings,
  sizes
});
